export default __webpack_public_path__ + "static/media/step-3-active_old.37b1fff0.svg";